import { FormComponent } from "../../../react-core/Html/FormComponent";
import { Contents } from "./Resource/Contents";
import * as React from "react";
import { Lightbox } from "../../../react-core/Html/Components/Lightbox";

export interface IErrorMessagePopupProps extends React.Props<ErrorMessagePopup> {
    showPopup: boolean;
    errorMessage: string;
    onClose: any;
}

export class ErrorMessagePopup extends FormComponent<IErrorMessagePopupProps, {}> {
    constructor(props: IErrorMessagePopupProps) {
        super(props);
    }

    public render(): JSX.Element {
        return <>{this.props.showPopup ? this.renderModal() : null}</>;
    }

    private renderModal(): JSX.Element {
        return (
            <>
                {this.props.showPopup && (
                    <Lightbox
                        cssWrapper="is-default-lightbox"
                        show={this.props.showPopup}
                        onClose={() => this.props.onClose()}
                        title={Contents.Header_Error}
                    >
                        <div>{this.props.errorMessage}</div>
                    </Lightbox>
                )}
            </>
        );
    }
}
